/* Initialises every [data-lp-carousel] on the page. Config comes from data
   attributes so no Liquid is inlined into script tags. Swiper stores the
   instance on the element as `el.swiper`, which landing-filters.js reads. */
(function () {
  function num(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function init() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-lp-carousel]:not([data-lp-ready])').forEach(function (el) {
      var perMobile = num(el.dataset.lpPerMobile, 1.2);
      var perTablet = num(el.dataset.lpPerTablet, 2.2);
      var perLaptop = num(el.dataset.lpPerLaptop, 3.2);
      var perDesktop = num(el.dataset.lpPerDesktop, 6);
      var gap = num(el.dataset.lpGap, 9);
      var scope = el.closest('.lp-carousel') || el.parentNode;

      el.dataset.lpReady = 'true';

      new Swiper(el, {
        slidesPerView: perMobile,
        slidesPerGroup: 1,
        spaceBetween: gap,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { slidesPerView: perTablet, slidesPerGroup: Math.max(1, Math.floor(perTablet)) },
          1024: { slidesPerView: perLaptop, slidesPerGroup: Math.max(1, Math.floor(perLaptop)) },
          1400: { slidesPerView: perDesktop, slidesPerGroup: Math.max(1, Math.floor(perDesktop)) }
        },
        navigation: {
          nextEl: scope.querySelector('[data-lp-next]'),
          prevEl: scope.querySelector('[data-lp-prev]')
        },
        pagination: {
          el: scope.querySelector('[data-lp-dots]'),
          clickable: true,
          dynamicBullets: true
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Sections re-rendered by the theme editor need re-initialising */
  document.addEventListener('shopify:section:load', init);
})();
